import React from 'react';
import { GrainOverlay } from './components/GrainOverlay';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { BeforeAfterGallery } from './components/BeforeAfterGallery';
import { About } from './components/About';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative min-h-screen bg-otter-black selection:bg-otter-cyan selection:text-otter-black" data-id="element-0">
      <GrainOverlay data-id="element-1" />
      <Nav data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Stats data-id="element-5" />
        <Services data-id="element-6" />
        <BeforeAfterGallery data-id="element-7" />
        <About data-id="element-8" />
        <Process data-id="element-9" />
        <Testimonials data-id="element-10" />
        <CtaBanner data-id="element-11" />
        <Contact data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}